export const SET_ADMIN_AUTH = 'SET_ADMIN_AUTH'



// WEBPACK FOOTER //
// ./src/store/adminPermissionStore/mutation-types.js